module.exports = __webpack_public_path__ + "media/00-Presentacion.7cb0b9a6.mp4";